import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = ['El Protocolo 40 Rendimiento Alpha (PDF Premium de implementación inmediata).', 'Guía de "Combustible Viril": Los alimentos exactos que actúan como precursores hormonales.', 'El Interruptor del Sueño Profundo: Técnica de 10 minutos para maximizar la producción de T durante la noche.', 'El Stack de Suplementos Alpha: La lista honesta de lo que sí funciona y lo que es un desperdicio de dinero.', 'Checklist de Rutina Diaria de Potencia: 15 minutos al día para blindar tu energía.'];
  return <section className="bg-navy-900 py-20 px-4 sm:px-6 lg:px-8" data-id="element-131">
      <div className="max-w-4xl mx-auto" data-id="element-132">
        <h2 className="font-playfair text-3xl sm:text-4xl font-bold text-center text-white mb-12" data-id="element-133">
          Lo que obtienes hoy
        </h2>
        <div className="grid gap-4" data-id="element-134">
          {deliverables.map((item, index) => <div key={index} className="flex items-center bg-navy-800 p-5 rounded-lg border border-navy-700 hover:border-gold-500/50 transition-colors" data-id="element-135">
              <CheckCircleIcon className="w-6 h-6 text-gold-500 shrink-0 mr-4" data-id="element-136" />
              <p className="text-lg text-[#e0e0e0]" data-id="element-137">{item}</p>
            </div>)}
        </div>
      </div>
    </section>;
}